export class ProductProperty {

  name: string;
  description: string;

  static fromJson(json: any): ProductProperty {
    var temp = new ProductProperty();
    temp.name = json.NAME;
    temp.description = json.DESCRIPTION;
    return temp;
  }

}
